import UtilsUrl from "../../utils/UtilsUrl";
import api from "./../api";

const addPrime = (formData) => {
  return api.post(UtilsUrl.rhURL() + `/primes/add_prime`, formData);
};
const getPrimes = (idUser) => {
  return api.get(UtilsUrl.rhURL() + "/primes/" + idUser);
};
const updatePrime = (primeData) => {
  return api.post(UtilsUrl.rhURL() + `/primes/update_prime`, primeData);
};
const checkNomPrime = (NomPrime, idUser) => {
  return api.get(
    UtilsUrl.rhURL() + `/primes/checkNomPrime/${NomPrime}/${idUser}`
  );
};
const getPrimesWithStatus = (idUser) => {
  return api.get(UtilsUrl.rhURL() + `/primes/primeStatus/${idUser}`);
};
const getPrimeByUser = async (idUser) => {
  const response = await api.get(
    UtilsUrl.rhURL() + `/primes/primePerEmployee/${idUser}`
  );
  return response.data;
};

export {
  addPrime,
  getPrimes,
  updatePrime,
  checkNomPrime,
  getPrimesWithStatus,
  getPrimeByUser,
};
